export const stickNavbar = (setScroll) => {
  if (window !== undefined) setScroll(window.scrollY > 350)
}
